/** Original illustrative assets belonging only to the five browser-demo identities. */
const details = [
  ['rack', 'bench'],
  ['barbell', 'dumbbells'],
  ['door', 'floor'],
  ['dumbbells', 'rack'],
  ['bench', 'door'],
] as const;
const captions: Record<string, string> = {
  rack: 'The rack, ready for the next session',
  bench: 'Bench station and plate storage',
  barbell: 'The evening lifting setup',
  dumbbells: 'A place for every dumbbell',
  door: 'Fresh air for the conditioning corner',
  floor: 'Open floor for warmups and carries',
};

export function isDemoGymImage(value?: string) {
  return /^\/images\/(?:demo-members\/member-[1-5]-gym(?:-(?:640|1024))?\.(?:png|webp)|gym-samples\/gym-sample-(?:rack|bench|barbell|dumbbells|door|floor)(?:-480)?\.(?:jpg|webp))$/.test(
    value || '',
  );
}

export function demoMemberMedia(userId?: string) {
  const match = /^demo-member-([1-5])$/.exec(userId || '');
  if (!match) return null;
  const number = Number(match[1]);
  const root = `/images/demo-members/member-${number}`;
  return {
    avatar: `${root}-avatar.webp`,
    cover: `${root}-gym.webp`,
    gallery: [
      { image: `${root}-gym.webp`, caption: 'The whole space' },
      ...details[number - 1].map((detail) => ({
        image: `/images/gym-samples/gym-sample-${detail}.webp`,
        caption: captions[detail],
      })),
    ],
  };
}
